import { T } from '../../i18n';
import { Services } from '../../services/index';
import type { DepartmentUserProfile } from '../../services/user.profile.service';
import { CurrentState } from '../../state/page.state';
import { CollectionInsightProcessModal } from '../collection.insight.process.modal/collection.insight.process.modal';

export const CollectionInsightProcessCtrl = {
	canTriggerInsightProcessing(currentUser: DepartmentUserProfile): boolean {
		const userIsAbleToRequestInsightProcessing =
			'isAbleToRequestInsightProcessing' in Services.User.current &&
			Services.User.current.isAbleToRequestInsightProcessing;
		return (
			(Services.UserProfile.isDepartmentAdmin(currentUser) ||
				Services.UserProfile.isDepartmentDataAdmin(currentUser)) &&
			userIsAbleToRequestInsightProcessing
		);
	},

	showInsightProcessModal(): void {
		const collections = CurrentState.Tag.collections;
		const modal = new CollectionInsightProcessModal(
			{
				title: T.COLLECTION_INSIGHT_PROCESS_TITLE,
				confirm: T.COLLECTION_INSIGHT_PROCESS,
				success: {
					key: T.COLLECTION_INSIGHT_PROCESS_SUCCESS,
					attrs: {
						count: collections.length,
					},
				},
			},
			collections
		);

		modal.open();
	},
};
